// Segmented control. Each segment is a real button carrying `aria-pressed`, so
// the choice is announced and reachable without seeing the colour.

import { button, h, srOnly } from '../dom';

export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
  /** Read out with the label, for the half of the sentence that is muted. */
  hint?: string;
}

export interface SegmentedOptions<T extends string> {
  options: SegmentedOption<T>[];
  value: T;
  /** Group label, also the `aria-label` of the group. */
  label: string;
  onChange: (value: T) => void;
}

export function segmented<T extends string>(options: SegmentedOptions<T>): HTMLElement {
  const row = h('div', {
    class: 'cf-segmented',
    attrs: { role: 'group', 'aria-label': options.label },
  });
  for (const option of options.options) {
    row.appendChild(
      button(
        {
          class: 'cf-segmented__seg',
          text: option.label,
          attrs: { 'aria-pressed': String(option.value === options.value) },
          on: { click: () => options.onChange(option.value) },
        },
        option.hint ? srOnly(option.hint) : null,
      ),
    );
  }
  return row;
}
